import { Link } from 'react-router-dom'
import { LinkRef, PageLink } from '../lib/internal_links'
import '../stylesheets/InternalLinks.scss'

type Props = Readonly<{
  label: string
  heading?: string
  links: readonly LinkRef[]
  pages?: readonly PageLink[]
}>

const CrawlLinks = ({ label, heading, links, pages }: Props) => {
  if (links.length === 0 && (!pages || pages.length === 0)) return null

  return (
    <nav className="crawl-links" aria-label={ label }>
      { heading ? <h2>{ heading }</h2> : null }
      {
        links.length > 0
          ? <ul>
            {
              links.map(link => (
                <li key={ link.href }>
                  <Link to={ link.href }>{ link.label }</Link>
                </li>
              ))
            }
          </ul>
          : null
      }
      {
        pages && pages.length > 0
          ? <ol>
            {
              pages.map(page => (
                <li key={ page.href }>
                  {
                    page.current
                      ? <span aria-current="page">{ page.label }</span>
                      : <Link to={ page.href } rel={ page.rel }>{ page.label }</Link>
                  }
                </li>
              ))
            }
          </ol>
          : null
      }
    </nav>
  )
}

export { CrawlLinks }
